import { render, staticRenderFns } from "./SubscriptionBar.vue?vue&type=template&id=8012d8d4&scoped=true&"
import script from "./SubscriptionBar.vue?vue&type=script&lang=js&"
export * from "./SubscriptionBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8012d8d4",
  null
  
)

export default component.exports